import { zIndex, colors as finamColors, spcColors } from '@finam/web-ui-kit';
import * as finamPalette from './finamPalette';
import * as spcPalette from './spcPalette';
import * as limePalette from './limePalette';
import mmaColors from './mmaColors';
export var getTheme = function getTheme(selectedTheme, variant) {
  var isFinam = ['dev-finam', 'finam'].indexOf(variant) !== -1;
  var isSpc = ['dev-spc', 'spc'].indexOf(variant) !== -1;
  var colors = isFinam ? finamColors : isSpc ? spcColors : mmaColors;
  var palette = isFinam ? finamPalette : isSpc ? limePalette : spcPalette;
  return {
    colors: colors,
    zIndex: zIndex,
    type: selectedTheme,
    fontFamily: 'Inter var, sans-serif',
    fontFamilyLegacy: 'Roboto, sans-serif',
    palette: selectedTheme === 'dark' ? palette.createThemePaletteBlack() : palette.createThemePaletteWhite()
  };
};